module.exports = __webpack_public_path__ + "img/direction-arrow-on.af67d055.svg";